<template>
  <div v-if="!loaded" v-html="info" style="text-align: left;" />
  <div v-else class="container mt-5 mb-5">
    <div class="d-flex justify-content-center row">
      <div class="col-md-10">
        <div class="row p-2 bg-white border rounded">
          <div class="col-md-3 mt-1">
            <!-- <img class="img-fluid img-responsive rounded product-image" src="https://i.imgur.com/QpjAiHq.jpg"> -->
            <img
              :src="formData.imgSrc"
              :alt="formData.title"
              class="img-fluid img-responsive rounded product-image">
          </div>
          <div class="col-md-6 mt-1">
            <h5>{{ formData.title }}</h5>
            <a :href="formData.internalLink" class="btn btn-outline-danger" target="_self">
              <!-- <i class="mdi mdi-bottle-wine"></i> {{ formData.producer }} -->
              <b-icon icon="house-door"></b-icon> {{ formData.producer }}
            </a>
            <span v-html="json2Html(formData.descr)"></span>
            <p> Grundpreis: {{ formData.basePrice }} </p>
            Verfügbarkeit: <b-icon v-if="formData.available" icon="check-circle-fill" style="font-size: 24px; color: green;"></b-icon>
            <b-icon v-else icon="x-circle-fill" style="font-size: 24px; color: red;"></b-icon>
            Lieferbar: <b-icon icon="truck" style="font-size: 24px; color: green;"></b-icon> {{ formData.delivery }} Werktage
          </div>
          <div class="align-items-center align-content-center col-md-3 border-left mt-1">
            <div class="d-flex flex-row align-items-center">
              <p> Preis:
                <span>{{ formData.currency }}</span>
                {{ formData.price }}
              </p>
            </div>
            <div class="d-flex flex-column mt-4">
              <button class="btn btn-success btn-sm"
                @click="$emit('comm-product-details', key)">Details</button>
              <button :class="formData.available?addBtnClass:addBtnClassDisabled"
                :disabled="!formData.available"
                @click="handleAdd2Basket">In den Warenkorb</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { json2Html } from '@/service/utils/ProsemirrorConverter'
import * as htmlUtil from '@/service/utils/html'
import * as events from '@/events'

const ADD_BTN_CLASS = 'btn btn-success',
  ADD_BTN_CLASS_DISABLED = 'btn-disabled',
  ADD_BTN_CONFETTI_CLASS = 'btn-confetti'

export default {
  name: 'comm-product',
  version: '0.0.6',
  props: {
    contentKey: {
      type: String,
      required: true
    },
    cmptData: {
      type: Object,
      default: () => null
    },
    genSeo: {
      type: Boolean,
      default: false
    },
    addBtnConfetti: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const _btnClassBase = this.addBtnConfetti ? ADD_BTN_CONFETTI_CLASS : ADD_BTN_CLASS
    return {
      /* Set to true if the content is loaded successfully, otherwise info is shown. */
      loaded: false,
      info: '... loading content!',
      addBtnClassBase: _btnClassBase,
      addBtnClass: _btnClassBase,
      addBtnClassDisabled: ADD_BTN_CLASS_DISABLED,
      key: '',
      formData: {}
    }
  }, // data
  async mounted () {
    this.loaded = false
    try {
      let _contentData
      if (!this.cmptData) {
        const _resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
          this.contentKey)
        _contentData = _resp.data.payload.content
      } else {
        _contentData = this.cmptData
      }

      this.formData = _contentData.fragments
      this.key = _contentData.key
      if (this.genSeo && _contentData.jsonld) {
        htmlUtil.addJsonldToHead(_contentData.jsonld)
      }
      this.loaded = true
    } catch (e) {
      this.info = 'Error loading the content!'
      this.loaded = false
      console.error('ERROR: Exception is: ', e)
    }
  }, // mounted
  methods: {
    json2Html,
    handleAdd2Basket () {
      console.log('TRACE-REMOVE: CommProduct.handleAdd2Basket: called!')
      const _payload = { commProduct: this.contentKey, amount: 1 }
      events.bus.emitGlobal(events.types.orders.GLGE_ADD_2_BASKET, _payload)
      this.addBtnClass = this.addBtnClassBase + ' animate'
      setTimeout(() => {
        this.addBtnClass = this.addBtnClassBase
      }, 700)
    } // handleAdd2Basket
  }
}
</script>

<style scoped>
/* @import '~@mdi/font/css/materialdesignicons.min.css'; */
@import '~bootstrap/dist/css/bootstrap.css';
/** TODO: check if necessary to reference all the *css files */
/* @import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~bootstrap-vue/dist/bootstrap-vue-icons.css'; */
@import '~@/assets/css/buttons.css';
</style>
